import axios from "axios";

export default {
    data() {
        return {
            processExport: false
        }
    },
    methods: {
        async exportExcel() {
            const columns = this.$refs.positionsTable?.exportColumnKeys || [];
            if (!columns.length) {
                this.serverError = this.t('exportNoColumns');
                if (typeof this.addNotify === 'function') this.addNotify({ text: this.serverError });
                return;
            }
            this.processExport = true;
            this.serverError = null;
            this.successMessage = null;

            const formDataToSubmit = new FormData();
            formDataToSubmit.append('export_all', '1');
            formDataToSubmit.append('columns', JSON.stringify(columns));

            try {
                const orderId = Number(this.$route?.params?.id || this.order?.id);
                const url = Number.isInteger(orderId) && orderId > 0
                    ? `/api/order/export/${orderId}/`
                    : `/api/order/export/`;
                const params = Object.entries(this.$route?.query || {}).reduce((result, [key, value]) => {
                    if (key !== 'page' && key !== 'page_size'
                        && (key === 'sort' || key === 'sort_dir' || key.startsWith('f_'))) {
                        result[key] = value;
                    }
                    return result;
                }, {});

                const response = await axios.post(url, formDataToSubmit,
                    {
                        params,
                        headers: {
                            'Content-Type': 'multipart/form-data'
                        }
                    });
                if (response.data.status == 'error') {
                    this.serverError= '';
                    for (let i in response.data.errors) {
                        console.log(typeof response.data.errors[i].code)
                        if (typeof response.data.errors[i].code == 'number') {
                            this.serverError = this.t('errors.serverError');
                            break;
                        }
                        else
                            this.serverError += response.data.errors[i].message+"<br>";
                    }
                    throw new Error(this.serverError);
                }
                else {
                    window.open(response.data.data, '_blank');
                    if (typeof this.addNotify === 'function') {
                        this.addNotify({text: this.t('orderPage.notify.exportSuccess')});
                    }
                }

            } catch (error) {
                this.serverError = error;
            } finally {
                this.processExport = false;
            }
        },
        async handlePositionsImported(data) {
            if (Number(data?.created || 0) > 0 && typeof this.load === 'function') {
                await this.load();
            } else if (Array.isArray(data?.positions) && data.positions.length && this.$refs.positionsTable) {
                await this.$refs.positionsTable.applyServerPositions(data.positions);
            }
            this.showDates = false;
        },
    }
}
